import { conceptQuestionsToPptDocument } from "../ppt/adapters/conceptQuestionsToPptDocument";
import { contentSimplifierToPptDocument } from "../ppt/adapters/contentSimplifierToPptDocument";
import { difficultyBalancerToPptDocument } from "../ppt/adapters/difficultyBalancerToPptDocument";
import { doubtSolverToPptDocument } from "../ppt/adapters/doubtSolverToPptDocument";
import { explainDifferentlyToPptDocument } from "../ppt/adapters/explainDifferentlyToPptDocument";
import { activityGeneratorToPptDocument } from "../ppt/adapters/activityGeneratorToPptDocument";
import { projectBuilderToPptDocument } from "../ppt/adapters/projectBuilderToPptDocument";
import { quickAssessmentToPptDocument } from "../ppt/adapters/quickAssessmentToPptDocument";
import { questionVariationsToPptDocument } from "../ppt/adapters/questionVariationsToPptDocument";
import { realWorldTaskToPptDocument } from "../ppt/adapters/realWorldTaskToPptDocument";
import { sectionBuilderToPptDocument } from "../ppt/adapters/sectionBuilderToPptDocument";
import { slideDeckGeneratorToPptDocument } from "../ppt/adapters/slideDeckGeneratorToPptDocument";
import { teachThisTopicToPptDocument } from "../ppt/adapters/teachThisTopicToPptDocument";
import { questionPaperToPptDocument } from "../ppt/adapters/questionPaperToPptDocument";
import { lessonFlowToWorksheetPdfDocument } from "../pdf/adapters/lessonFlowToWorksheetPdfDocument";

const REGISTRY = {
  "quick-sheets": {
    toDocument: (result) => lessonFlowToWorksheetPdfDocument(result),
    getContentKey: (result) => result?.title ?? result?.topicLabel ?? "quick-sheets",
    getTitle: (result) => result?.title ?? result?.topicLabel ?? "Quick Sheets",
  },
  "concept-questions": {
    toDocument: conceptQuestionsToPptDocument,
    getContentKey: (result) => result?.title ?? "concept-questions",
    getTitle: (result) => result?.title ?? "Concept Questions",
  },
  "question-variations": {
    toDocument: questionVariationsToPptDocument,
    getContentKey: (result) => result?.title ?? "question-variations",
    getTitle: (result) => result?.title ?? "Question Variations",
  },
  "quick-assessment": {
    toDocument: quickAssessmentToPptDocument,
    getContentKey: (result) => result?.title ?? "quick-assessment",
    getTitle: (result) => result?.title ?? "Quick Assessment",
  },
  "teach-this-topic": {
    toDocument: teachThisTopicToPptDocument,
    getContentKey: (result) => result?.title ?? result?.topicLabel ?? "teach-this-topic",
    getTitle: (result) => result?.title ?? result?.topicLabel ?? "Teach This Topic",
  },
  "explain-differently": {
    toDocument: explainDifferentlyToPptDocument,
    getContentKey: (result) => result?.title ?? result?.topicLabel ?? "explain-differently",
    getTitle: (result) => result?.title ?? result?.topicLabel ?? "Explain Differently",
  },
  "content-simplifier": {
    toDocument: contentSimplifierToPptDocument,
    getContentKey: (result) => result?.title ?? "content-simplifier",
    getTitle: (result) => result?.title ?? "Content Simplifier",
  },
  "question-paper": {
    toDocument: questionPaperToPptDocument,
    getContentKey: (result) => result?.title ?? result?.topicLabel ?? "question-paper",
    getTitle: (result) => result?.title ?? result?.topicLabel ?? "Question Paper",
  },
  "section-builder": {
    toDocument: sectionBuilderToPptDocument,
    getContentKey: (result) => result?.title ?? "section-builder",
    getTitle: (result) => result?.title ?? "Section Builder",
  },
  "difficulty-balancer": {
    toDocument: difficultyBalancerToPptDocument,
    getContentKey: (result) => result?.title ?? "difficulty-balancer",
    getTitle: (result) => result?.title ?? "Difficulty Balancer",
  },
  "doubt-solver": {
    toDocument: doubtSolverToPptDocument,
    getContentKey: (result) => result?.question ?? result?.title ?? "doubt-solver",
    getTitle: (result) => result?.question ?? result?.title ?? "Doubt Solver",
  },
  "slide-deck-generator": {
    toDocument: slideDeckGeneratorToPptDocument,
    getContentKey: (result) => result?.title ?? "slide-deck",
    getTitle: (result) => result?.title ?? "Slide Deck",
  },
  "project-builder": {
    toDocument: projectBuilderToPptDocument,
    getContentKey: (result) => result?.title ?? "project-builder",
    getTitle: (result) => result?.title ?? "Project Builder",
  },
  "activity-generator": {
    toDocument: activityGeneratorToPptDocument,
    getContentKey: (result) => result?.title ?? "activity-generator",
    getTitle: (result) => result?.title ?? "Activity Generator",
  },
  "real-world-task": {
    toDocument: realWorldTaskToPptDocument,
    getContentKey: (result) => result?.title ?? "real-world-task",
    getTitle: (result) => result?.title ?? "Real World Task",
  },
};

export function getLibraryDocumentConfig(toolId) {
  return REGISTRY[toolId] ?? null;
}

export function buildLibraryDocumentForTool(toolId, result) {
  const config = getLibraryDocumentConfig(toolId);
  if (!config || !result) {
    return null;
  }
  return {
    document: config.toDocument(result),
    contentKey: config.getContentKey(result),
    title: config.getTitle(result),
  };
}
